<template>
    <div class="default-vue">
        <h3>Bienvenue sur</h3>
        <img src="../assets/logo.svg" alt="logo-goMediCAL" class="logo-gomedaical">
        <!-- <h3>Default vue</h3> -->
        <img src="../assets/stethoscope.svg" alt="stethoscope" class="image-stet">
        <!-- <div class="citation">
            <span> La santé est, de tous les trésors, le plus précieux et le plus mal gardé.<br> Joseph Sanial-Dubay</span>
        </div> -->
        <div class="links">
            <ul>
                <li><a href="https://gomedical.io/" class="discover">Découvrir</a></li>
                <li><a href="https://goo.gl/NNw2AC" class="download">Télécharger</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style>
.default-vue {
    width: 50%;
    margin: auto;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.default-vue .logo-gomedaical {
    height: 10%;
}
.default-vue .image-stet {
    margin-top: 10px;
    height: 30%;
}
.default-vue h3 {
    font-size: 2em;
    margin-bottom: 20px;
    color: #000;
}
.links {
    display: flex;
    margin-top: 30px;
}
.links ul {
    list-style: none;
    width: 100%;
    display: flex;
    justify-content: center;

}
.links a {
    text-decoration: none;
    color: #fff;
    border-radius: 30px;
    margin: 5px;
    padding: 10px 65px;
    font-weight: bold;
    font-size: 1.4em;
}
.discover {
    border: 1px solid #2ba359;
    background: #2ba359;
}
.download {
    border: 1px solid #FFD44F;
    background: #FFD44F;
}
.citation {
    width: 70%;
    margin:  0 auto;
    display: flex;
    justify-content: center;
}
.citation span {
    text-align: center;
    font-size: 1em;
}
</style>
